/* istanbul ignore file */

import { Show } from 'framework/show';
import { ShowSection, SectionRow, FieldListLayout, ShowPageLayout } from 'framework/ui/layout';
import { EnumField, HtmlField, TextField } from 'framework/ui/field';
import ViewVacancyPublicationPageMenu from 'domain/recruiting/vacancy/publication/Show/ViewVacancyPublicationPageMenu';
import VacancyPublicationEntityHeader from 'domain/recruiting/vacancy/publication/shared/VacancyPublicationEntityHeader';
import VacancyPublicationDetailsField from 'domain/recruiting/vacancy/shared/field/VacancyPublicationDetailsField';
import VacancyPublicationField from 'domain/recruiting/vacancy/shared/field/VacancyPublicationField';
import VacancyGroupLinkField from '../../../shared/VacancyGroupLinkField';
import useVacancyPublicationService from '../vacancyPublicationService';
import {
  VACANCY_PUBLICATION_PLATFORMS,
  VACANCY_PUBLICATION_STATUSES,
} from '../../../../vacancy/publication/shared/vacancyPublicationService';
import PublicationDetailsField from '../field/PublicationDetailsField';
import { useParams } from 'react-router-dom';
import EditVacancyPublicationButton from '../shared/button/EditVacancyPublicationButton';
import { RECRUITING_VACANCY_PUBLICATION_UPDATE } from 'domain/shared/newVacancy';
import PublicationsEnglishLevelTextField from 'domain/recruiting/newVacancy/show/publications/field/PublicationsEnglishLevelTextField';
import SingleVacancyGroupPublicationBreadcrumbs from 'domain/recruiting/newVacancy/show/publications/shared/SingleVacancyGroupPublicationBreadcrumbs';

const ViewVacancyPublication = () => {
  const { publicationId } = useParams<Dictionary<string>>();
  const { getById } = useVacancyPublicationService();

  return (
    <Show getDataMethod={() => getById(publicationId!)}>
      <ShowPageLayout
        buttons={[
          <EditVacancyPublicationButton source="id" permissionToCheck={RECRUITING_VACANCY_PUBLICATION_UPDATE} />,
        ]}
        menu={<ViewVacancyPublicationPageMenu />}
        breadcrumbs={<SingleVacancyGroupPublicationBreadcrumbs />}
        entityHeader={<VacancyPublicationEntityHeader />}
      >
        <ShowSection title="Vacancy publication information">
          <SectionRow>
            <VacancyGroupLinkField source="vacancyGroupAlias" label="Vacancy group" />
            <TextField source="name" />
            <FieldListLayout source="englishLevels" label="Relevant english levels">
              <PublicationsEnglishLevelTextField source="englishLevels" />
            </FieldListLayout>
            <FieldListLayout source="countryOfResidences" label="Relevant country of residences">
              <VacancyPublicationField />
            </FieldListLayout>
            <EnumField source="type" label="Publication platform" options={VACANCY_PUBLICATION_PLATFORMS} />
            <EnumField source="status" label="Status" options={VACANCY_PUBLICATION_STATUSES} />
          </SectionRow>
        </ShowSection>
        <ShowSection title="Additional vacancy publication fields">
          <FieldListLayout source="formFields" hasSeparator>
            <VacancyPublicationDetailsField />
          </FieldListLayout>
        </ShowSection>
        <ShowSection title="Public description">
          <HtmlField source="description" label="" />
        </ShowSection>

        <ShowSection title="Vacancy publication details">
          <FieldListLayout source="publicationDetails" hasSeparator>
            <PublicationDetailsField />
          </FieldListLayout>
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default ViewVacancyPublication;
